export const ADD_PRODUCT_BRAND_SUCCESS = "ADD_PRODUCT_BRAND_SUCCESS";
export const GET_ALL_PRODUCT_BRAND_REQUEST = "GET_ALL_PRODUCT_BRAND_REQUEST";
export const GET_ALL_PRODUCT_BRAND_SUCCESS = "GET_ALL_PRODUCT_BRAND_SUCCESS";
export const DELETE_PRODUCT_BRAND_SUCCESS = "DELETE_PRODUCT_BRAND";
export const GET_ALL_PRODUCT_BRAND_FAILURE = "GET_ALL_PRODUCT_BRAND_FAILURE";
export const UPDATE_PRODUCT_BRAND_SUCCESS = "UPDATE_PRODUCT_BRAND_SUCCESS";
